import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-receipt-info',
  templateUrl: './receipt-info.component.html',
  styleUrls: ['./receipt-info.component.scss']
})
export class ReceiptInfoComponent implements OnInit {
  @Input() data: any;

  constructor() { }

  ngOnInit() {
  }

}
